class ShippingInfoSelector {
  constructor() {
    this.selector = document.querySelector('[data-selector]');
    if (!this.selector) return;

    this.trigger = this.selector.querySelector('.shipping-country-selector__trigger');
    this.dropdown = this.selector.querySelector('[data-dropdown]');
    this.searchInput = this.selector.querySelector('[data-search-input]');
    this.countryList = this.selector.querySelector('[data-country-list]');
    this.flagElement = this.selector.querySelector('[data-flag]');
    this.countryNameElement = this.selector.querySelector('[data-country-name]');
    this.contentArea = document.querySelector('[data-content-area]');
    
    this.loadData();
    this.init();
  }

  loadData() {
    const dataElement = document.querySelector('[data-shipping-info-config]');
    if (!dataElement) return;
    
    try {
      const data = JSON.parse(dataElement.textContent);
      this.currentCountry = data.currentCountry;
      this.featuredCountries = data.featuredCountries ? data.featuredCountries.split(',').map(c => c.trim().toUpperCase()) : [];
      this.availableCountries = data.availableCountries || [];
      this.blocks = data.blocks || [];
    } catch (error) {
      console.error('Error parsing shipping info data:', error);
      this.currentCountry = 'GB';
      this.featuredCountries = [];
      this.availableCountries = [];
      this.blocks = [];
    }
  }

  init() {
    this.buildCountryList();
    this.attachEventListeners();
    
    // Auto-select current country, default to GB if not available
    const countryToSelect = this.currentCountry || 'GB';
    this.selectCountry(countryToSelect, true);
    
    // Restore from localStorage if available
    /*const savedCountry = localStorage.getItem('shipping-selected-country');
    if (savedCountry) {
      this.selectCountry(savedCountry, true);
    }*/
  }

  buildCountryList() {
    const options = this.countryList.querySelectorAll('.shipping-country-selector__option');
    
    options.forEach(option => {
      option.addEventListener('click', () => {
        const countryCode = option.getAttribute('data-country-code');
        this.selectCountry(countryCode);
        this.closeDropdown();
      });
    });
  }

  attachEventListeners() {
    // Toggle dropdown
    this.trigger.addEventListener('click', () => {
      this.toggleDropdown();
    });
    
    // Search functionality
    this.searchInput.addEventListener('input', (e) => {
      this.filterCountries(e.target.value);
    });
    
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!this.selector.contains(e.target)) {
        this.closeDropdown();
      }
    });
    
    // Keyboard navigation
    this.searchInput.addEventListener('keydown', (e) => {
      this.handleKeyboardNavigation(e);
    });
    
    this.countryList.addEventListener('keydown', (e) => {
      this.handleKeyboardNavigation(e);
    });
  }

  handleKeyboardNavigation(e) {
    const visibleOptions = Array.from(this.countryList.querySelectorAll('.shipping-country-selector__option'))
      .filter(option => !option.parentElement.hidden);
    
    if (visibleOptions.length === 0) return;

    const currentFocus = document.activeElement;
    let currentIndex = visibleOptions.indexOf(currentFocus);

    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (currentFocus === this.searchInput || currentIndex === -1) {
          visibleOptions[0].focus();
        } else if (currentIndex < visibleOptions.length - 1) {
          visibleOptions[currentIndex + 1].focus();
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (currentIndex > 0) {
          visibleOptions[currentIndex - 1].focus();
        } else if (currentIndex === 0) {
          this.searchInput.focus();
        }
        break;

      case 'Home':
        e.preventDefault();
        visibleOptions[0].focus();
        break;

      case 'End':
        e.preventDefault();
        visibleOptions[visibleOptions.length - 1].focus();
        break;

      case 'Enter':
        if (currentIndex !== -1) {
          e.preventDefault();
          visibleOptions[currentIndex].click();
        }
        break;

      case 'Escape':
        e.preventDefault();
        this.closeDropdown();
        this.trigger.focus();
        break;

      case 'Tab':
        // Allow default tab behavior but close dropdown
        this.closeDropdown();
        break;
    }
  }

  toggleDropdown() {
    const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dropdown.hidden = false;
    this.searchInput.focus();
  }

  closeDropdown() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.dropdown.hidden = true;
    this.searchInput.value = '';
    this.filterCountries('');
  }

  filterCountries(searchTerm) {
    const term = searchTerm.toLowerCase().trim();
    const options = this.countryList.querySelectorAll('.shipping-country-selector__option');
    const divider = this.countryList.querySelector('[data-divider]');
    
    let visibleFeaturedCount = 0;
    let visibleRegularCount = 0;
    let featuredCount = this.featuredCountries.length;
    
    options.forEach((option, index) => {
      const countryName = option.getAttribute('data-country-name').toLowerCase();
      const countryCode = option.getAttribute('data-country-code').toLowerCase();
      const matches = countryName.includes(term) || countryCode.includes(term);
      const isFeatured = index < featuredCount;
      
      option.parentElement.hidden = !matches;
      
      if (matches) {
        if (isFeatured) {
          visibleFeaturedCount++;
        } else {
          visibleRegularCount++;
        }
      }
    });
    
    // Show divider only if we have visible countries in both sections
    if (divider) {
      if (term) {
        // When searching, show divider only if both sections have results
        divider.hidden = !(visibleFeaturedCount > 0 && visibleRegularCount > 0);
      } else {
        // When not searching, show divider if we have featured countries
        divider.hidden = false;
      }
    }
  }

  selectCountry(countryCode, skipLocalStorage = false) {
    const code = countryCode.toUpperCase();
    
    // Update trigger display
    this.updateTriggerDisplay(code);
    
    // Mark selected option
    const options = this.countryList.querySelectorAll('.shipping-country-selector__option');
    options.forEach(option => {
      const isSelected = option.getAttribute('data-country-code') === code;
      option.setAttribute('aria-selected', isSelected);
    });
    
    // Update content
    this.updateContent(code);
    
    // Save to localStorage
    if (!skipLocalStorage) {
      localStorage.setItem('shipping-selected-country', code);
    }
  }

  updateTriggerDisplay(countryCode) {
    const option = this.countryList.querySelector(`[data-country-code="${countryCode}"]`);
    if (!option) return;
    
    const countryName = option.getAttribute('data-country-name');
    
    // Update flag
    this.flagElement.innerHTML = `
      <img 
        src="https://cdn.shopify.com/static/images/flags/${countryCode.toLowerCase()}.svg" 
        alt="${countryName} flag"
        onerror="this.style.display='none'"
      >
    `;
    
    // Update text
    this.countryNameElement.textContent = countryName;
  }

  async updateContent(countryCode) {
    const allCountryContents = this.contentArea.querySelectorAll('.shipping-info__country-content');
    
    allCountryContents.forEach(content => {
      const contentCountry = content.getAttribute('data-country');
      if (contentCountry === countryCode) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  }


}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ShippingInfoSelector();
  });
} else {
  new ShippingInfoSelector();
}